import { FileText, Video, Music, BookOpen, Image, Globe } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface MediaTypeStyle {
  border: string
  iconBg: string
  iconText: string
  btnBg: string
  btnBorder: string
  btnText: string
  label: string
  Icon: LucideIcon
}

export const MEDIA_TYPE_STYLES: Record<string, MediaTypeStyle> = {
  document: {
    border: 'border-l-blue-400',
    iconBg: 'bg-blue-400/10',
    iconText: 'text-blue-500',
    btnBg: 'bg-blue-500/10',
    btnBorder: 'border-blue-500/30',
    btnText: 'text-blue-600 dark:text-blue-400',
    label: 'Document',
    Icon: FileText,
  },
  video: {
    border: 'border-l-violet-400',
    iconBg: 'bg-violet-400/10',
    iconText: 'text-violet-500',
    btnBg: 'bg-violet-500/10',
    btnBorder: 'border-violet-500/30',
    btnText: 'text-violet-600 dark:text-violet-400',
    label: 'Video',
    Icon: Video,
  },
  audio: {
    border: 'border-l-orange-400',
    iconBg: 'bg-orange-400/10',
    iconText: 'text-orange-500',
    btnBg: 'bg-orange-500/10',
    btnBorder: 'border-orange-500/30',
    btnText: 'text-orange-600 dark:text-orange-400',
    label: 'Audio',
    Icon: Music,
  },
  scorm: {
    border: 'border-l-emerald-400',
    iconBg: 'bg-emerald-400/10',
    iconText: 'text-emerald-500',
    btnBg: 'bg-emerald-500/10',
    btnBorder: 'border-emerald-500/30',
    btnText: 'text-emerald-600 dark:text-emerald-400',
    label: 'Interactive Course',
    Icon: BookOpen,
  },
  image: {
    border: 'border-l-pink-400',
    iconBg: 'bg-pink-400/10',
    iconText: 'text-pink-500',
    btnBg: 'bg-pink-500/10',
    btnBorder: 'border-pink-500/30',
    btnText: 'text-pink-600 dark:text-pink-400',
    label: 'Image',
    Icon: Image,
  },
  web: {
    border: 'border-l-cyan-400',
    iconBg: 'bg-cyan-400/10',
    iconText: 'text-cyan-500',
    btnBg: 'bg-cyan-500/10',
    btnBorder: 'border-cyan-500/30',
    btnText: 'text-cyan-600 dark:text-cyan-400',
    label: 'Web Page',
    Icon: Globe,
  },
}

const DEFAULT_STYLE: MediaTypeStyle = {
  border: 'border-l-gray-400',
  iconBg: 'bg-gray-400/10',
  iconText: 'text-gray-500',
  btnBg: 'bg-gray-500/10',
  btnBorder: 'border-gray-500/30',
  btnText: 'text-gray-600 dark:text-gray-400',
  label: 'Source',
  Icon: FileText,
}

export function getMediaTypeStyle(mediaType: string): MediaTypeStyle {
  return MEDIA_TYPE_STYLES[mediaType] ?? DEFAULT_STYLE
}
